import { Injectable } from "@angular/core";
import { OpenBrowserUrlRepo } from "@app/core/open-browser-url/domain/open-browser-url.repo";

@Injectable({ providedIn: "root" })
export class OpenBrowserUrlUseCase {
  constructor(private openBrowserUrlRepo: OpenBrowserUrlRepo) {}

  execute(url: string) {
    return this.openBrowserUrlRepo.open(url);
  }
}
